<div *transloco="let t">
	<div class="mobilescroll">
		<ng-container>
			<mat-dialog-content>
				<div>
					<div class="flex flex-row justify-space-between items-center">
						<h1 class="title">{{ t('consumptionInformation.title') }}</h1>
						<div class="flex-1"></div>
						<button aria-label="close dialog" mat-dialog-close mat-icon-button>
							<mat-icon>close</mat-icon>
						</button>
					</div>
					<h3 class="title mt-0 mb-5" cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane">
						{{ t('consumptionInformation.consumptionQuantity') }}
					</h3>
				</div>
				<div
					[ngClass]="{ 'flex-col': this.layoutService.isMobile(), 'flex-row': !this.layoutService.isMobile() }"
					class="flex justify-around items-center">
					<mat-form-field appearance="fill">
						<mat-label>{{ t('common.fromLower') }}</mat-label>
						<input [formControl]="periodFrom" [matDatepicker]="dp" matInput />
						<mat-datepicker-toggle [for]="dp" matSuffix></mat-datepicker-toggle>
						<mat-datepicker #dp></mat-datepicker>
					</mat-form-field>
					<mat-form-field appearance="fill">
						<mat-label>{{ t('common.to') }}</mat-label>
						<input [formControl]="periodTo" [matDatepicker]="dpTo" matInput />
						<mat-error>
							{{ dateError }}
						</mat-error>
						<mat-datepicker-toggle [for]="dpTo" matSuffix></mat-datepicker-toggle>
						<mat-datepicker #dpTo></mat-datepicker>
					</mat-form-field>
					<button (click)="loadData()" mat-icon-button>
						<mat-icon [svgIcon]="icons.get('refresh')"></mat-icon>
					</button>
				</div>
			</mat-dialog-content>
		</ng-container>
		@if (!finishedLoading) {
			<div class="flex flex-row justify-center" @fadeInUp>
				<mat-spinner color="primary"></mat-spinner>
			</div>
		}
		@if (showData) {
			<div class="flex flex-row">
				<mat-list [ngClass]="{ 'w-[90%]': this.layoutService.isMobile(), 'w-[70%]': !this.layoutService.isMobile() }">
					<mat-list-item>
						{{ this.layoutService.isMobile() ? t('consumptionInformation.amountCIsCreatedMobile') : t('consumptionInformation.amountCIsCreated') }}
					</mat-list-item>
					<mat-list-item>
						{{ this.layoutService.isMobile() ? t('consumptionInformation.amountSentPmMobile') : t('consumptionInformation.amountSentPm') }}
					</mat-list-item>
					<mat-list-item>
						{{
							this.layoutService.isMobile()
								? t('consumptionInformation.amountSentResidentMobile')
								: t('consumptionInformation.amountSentResident')
						}}
					</mat-list-item>
					<mat-list-item>
						{{ this.layoutService.isMobile() ? t('consumptionInformation.amountSentOwnerMobile') : t('consumptionInformation.amountSentOwner') }}
					</mat-list-item>
					<mat-list-item>
						{{
							this.layoutService.isMobile() ? t('consumptionInformation.totalMonthsSentPmMobile') : t('consumptionInformation.totalMonthsSentPm')
						}}
					</mat-list-item>
				</mat-list>
				<mat-list [ngClass]="{ 'w-[10%]': this.layoutService.isMobile(), 'w-[30%]': !this.layoutService.isMobile() }">
					<mat-list-item>{{ currentRealEstateEedCount.totalBillableEed }}</mat-list-item>
					<mat-list-item>{{ currentRealEstateEedCount.totalEedPrintedByScToPm }}</mat-list-item>
					<mat-list-item>{{ currentRealEstateEedCount.totalEedPrintedByScToResident }}</mat-list-item>
					<mat-list-item>{{ currentRealEstateEedCount.totalEedPrintedByScToOwner }}</mat-list-item>
					<mat-list-item>{{ currentRealEstateEedCount.totalMonthsEedPrintedByScToPm }}</mat-list-item>
				</mat-list>
			</div>
			<mat-accordion class="example-headers-align" multi>
				<mat-expansion-panel>
					<mat-expansion-panel-header>
						<mat-panel-title>
							<h3 class="title">{{ t('consumptionInformation.listingPerResident') }}</h3>
						</mat-panel-title>
					</mat-expansion-panel-header>
					<table @stagger [dataSource]="dataSourceResidents" class="w-full" mat-table>
						<ng-container matColumnDef="number">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('common.number') }}
							</th>
							<td *matCellDef="let resident" mat-cell>{{ resident.number }}/{{ resident.subNumber }}</td>
						</ng-container>
						<ng-container matColumnDef="name">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.resident') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								<div class="residenceName" attr.title="{{ resident.name }}">
									{{ resident.name }}
								</div>
							</td>
						</ng-container>
						<ng-container matColumnDef="validFrom">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.validFrom') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ dateUtil.setDateFormatByActiveLang(resident.validFrom, '', false) }}
							</td>
						</ng-container>
						<ng-container matColumnDef="validTo">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.validTo') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ dateUtil.setDateFormatByActiveLang(resident.validTo, '', false) }}
							</td>
						</ng-container>
						<ng-container matColumnDef="totalEedCount">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.totalCreated') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ resident.totalEedCount }}
							</td>
						</ng-container>
						<ng-container matColumnDef="totalEedBillableCount">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.totalBillable') }}
							</th>
							<td *matCellDef="let resident" mat-cell [attr.data-label]="t('consumptionInformation.totalBillable')">
								{{ resident.totalEedBillableCount }}
							</td>
						</ng-container>
						<ng-container matColumnDef="printedEedFromScToPm">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.amountSentPmMobile') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ resident.printedEedFromScToPm }}
							</td>
						</ng-container>
						<ng-container matColumnDef="printedEedFromScToResident">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.amountSentResidentMobile') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ resident.printedEedFromScToResident }}
							</td>
						</ng-container>
						<ng-container matColumnDef="printedEedFromScToOwner">
							<th *matHeaderCellDef mat-header-cell>
								{{ t('consumptionInformation.amountSentOwnerMobile') }}
							</th>
							<td *matCellDef="let resident" mat-cell>
								{{ resident.printedEedFromScToOwner }}
							</td>
						</ng-container>
						<tr *matHeaderRowDef="visibleColumnsResident; sticky: true" mat-header-row mat-header-row></tr>
						<tr *matRowDef="let row; columns: visibleColumnsResident" @fadeInUp class="hover:bg-hover trans-ease-out cursor-pointer" mat-row></tr>
						<!-- Row shown when there is no matching data. -->
						<tr *matNoDataRow class="mat-row">
							<td class="mat-cell" colspan="4">
								<div class="ml-4">{{ t('dashboard.noDataFound') }}</div>
							</td>
						</tr>
					</table>
				</mat-expansion-panel>
			</mat-accordion>
		}
	</div>
</div>
